import { PROCESSO_PASSOS_DEFAULT } from '../constants'

interface ProcessStepsProps {
  doneCount?: number
  passos?: string[]
  compact?: boolean
  celebrate?: boolean
}

export function ProcessSteps({
  doneCount = 0,
  passos = PROCESSO_PASSOS_DEFAULT,
  compact = false,
  celebrate = false,
}: ProcessStepsProps) {
  const done = Math.max(0, Math.min(passos.length, Number(doneCount) || 0))
  const wrapCls = [
    'cr-process',
    celebrate ? 'cr-process-success' : '',
    compact ? 'cr-process-compact' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={wrapCls} role="region" aria-label="Como funciona o processo seletivo">
      <p className="cr-process-title">{compact ? 'Seu progresso' : 'Como funciona o processo'}</p>
      {!compact && (
        <p className="cr-process-note">
          As etapas podem variar conforme a vaga. Você será avisado a cada avanço.
        </p>
      )}
      <ol className="cr-steps">
        {passos.map((label, i) => {
          const n = i + 1
          let cls = 'cr-step'
          if (n <= done) cls += ' done'
          else if (n === done + 1) cls += ' current'
          return (
            <li key={label} className={cls}>
              <span className="cr-step-dot" aria-hidden="true">
                {n <= done ? '✓' : String(n)}
              </span>
              <span className="cr-step-label">{label}</span>
            </li>
          )
        })}
      </ol>
    </div>
  )
}
